import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { filter } from 'rxjs/operators';
import { LoaderService } from './loader.service';

@Component({
  selector: 'ps-ui-loader',
  template: `<div id="loader-wrapper" *ngIf="loading">
    <div id="loader"><span></span></div>
  </div>`,
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent implements OnInit {
  loading = false;

  constructor(private _loader: LoaderService, private _cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    this._cd.detach();
    this._loader.loading$
      .pipe(filter((loading) => this.loading !== loading))
      .subscribe((loading) => {
        this.loading = loading;
        this._cd.detectChanges();
      });
  }
}
